import { useEffect, useState } from "react";
import { auth, db } from "../config/firebase";
import { doc, getDoc } from "firebase/firestore";

export function useAdminStatus() {
    const [isAdmin, setIsAdmin] = useState(false);
  
    useEffect(() => {
      const checkAdminStatus = async () => {
        if (!auth.currentUser) return;
        
        try {
          const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid));
          if (userDoc.exists()) {
            setIsAdmin(userDoc.data().isAdmin === true);
          }
        } catch (error) {
          console.error('Error checking admin status:', error);
        }
      };
  
      checkAdminStatus();
    }, []);
  
    return { isAdmin };
  }
  